import {get_nested} from "../../../services/JsonHandler";
import {isNullOrUndefined} from "../../../services/Validator";
import NeoFlashQuestionOptionsList from "../../lists/flashScreen/NeoFlashQuestionOptionsList";
import NeoFlashQuestion from "./NeoFlashQuestion";

export default function NeoFlashCoreContent({ question,
                                               optionSelected,
                                               setOptionSelected,
                                               setOpenDontKnowDialog }) {
    // Used in MetaFlashScreen to display question content in a card
    // in desktop and tablet format

    // PROPERTIES
    const options = get_nested(['options'], question, null)

    // BUILD
    if (isNullOrUndefined(question))
        return null
    return (
        <div className={"overflow-auto w-full grow flex flex-col justify-start items-center"}>
            <div className={"mt-[24px] w-full flex items-stretch space-x-[24px]"}>
                <NeoFlashQuestion question={question} />
                <NeoFlashQuestionOptionsList options={options}
                                             optionSelected={optionSelected}
                                             setOptionSelected={setOptionSelected}
                                             onDontKnowPress={() => setOpenDontKnowDialog(true)}/>
            </div>
        </div>
    );
}